import React from 'react'

import clsx from 'clsx'

import Typography from 'components/Typography'

import classes from './PercentLabelDisplay.module.scss'

/** @type {import("./types").default} */
const PercentLabelDisplay = ({ hideLabelInMobileTablet = false, label = '', recommendPercentage = '0', className }) => {
  return (
    <div className={clsx('PercentLabelDisplay', classes.root, className)}>
      <div className={classes.percentage}>
        <Typography component="span" variant="display-sm" className={classes.textVariation}>
          {recommendPercentage}
        </Typography>
        <Typography component="span" variant="display-xs" className={classes.percentageSymbol}>
          %
        </Typography>
      </div>
      <Typography
        component="span"
        className={clsx(classes.recommendText, {
          [classes.recommendTextHide]: hideLabelInMobileTablet,
        })}
        variant="body-xs"
      >
        {label}
      </Typography>
    </div>
  )
}

export default PercentLabelDisplay
